exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.contact {\n  background-color: #e3001a;\n  color: white;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 1.2em;\n  display: inline-block;\n  padding: 40px 15px;\n  margin-bottom: 40px; }\n  @media (max-width: 320px) {\n    div.contact {\n      font-size: 0.9em;\n      padding: 30px 10px;\n      margin-left: 20px; } }\n  @media (min-width: 321px) and (max-width: 480px) {\n    div.contact {\n      font-size: 1.0em;\n      padding: 30px 10px;\n      margin-left: 30px; } }\n  @media (min-width: 481px) and (max-width: 767px) {\n    div.contact {\n      margin-top: 30px;\n      margin-left: 35px; } }\n  @media (min-width: 768px) and (max-width: 991px) {\n    div.contact {\n      margin-top: 30px;\n      margin-left: 40px; } }\n  @media (min-width: 992px) and (max-width: 1199px) {\n    div.contact {\n      margin-top: 30px;\n      margin-left: 60px; } }\n  @media (min-width: 1200px) {\n    div.contact {\n      margin-top: 30px;\n      margin-left: 80px;\n      position: absolute;\n      right: 100px;\n      top: 0px;\n      margin-top: -80px; } }\n  div.contact div.container-fluid div {\n    padding: 0; }\n    div.contact div.container-fluid div a {\n      color: white;\n      text-decoration: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/contact/contact.component.scss
// module id = 340
// module chunks = 1